import React from "react";

const TopContainer = ({ children }) => {
  return (
    <div className="pt-8 md:pt-12 lg:pt-14">{children}</div>
  );
};

export default TopContainer;
